export const GET_ALLOW_PROFILE = "GET_ALLOW_PROFILE";
export const GET_ALLOW_PROFILE_SUCCESS = "GET_ALLOW_PROFILE_SUCCESS";
export const GET_ALLOW_PROFILE_FAILED = "GET_ALLOW_PROFILE_FAILED";

export const VALIDATE_TIN = "VALIDATE_TIN";
export const VALIDATE_TIN_SUCCESS = "VALIDATE_TIN_SUCCESS";
export const VALIDATE_TIN_FAILED = "VALIDATE_TIN_FAILED";

export const SEARCH_TIN = "SEARCH_TIN";
export const RESET_TIN = "RESET_TIN";
export const SEARCH_TIN_SUCCESS = "SEARCH_TIN_SUCCESS";
export const SEARCH_TIN_FAILED = "SEARCH_TIN_FAILED";
